export const GTP_SIGNIFICANCE_STAR_GAP = 8;
export const GTP_SIGNIFICANCE_STAR_RADIUS = 6;
export const GTP_SIGNIFICANCE_STAR_SPACING = GTP_SIGNIFICANCE_STAR_RADIUS * 2 + 1;

export function significanceStarPath(
  cx: number,
  cy: number,
  outerRadius = GTP_SIGNIFICANCE_STAR_RADIUS,
): string {
  const innerRadius = outerRadius * 0.36;
  const parts: string[] = [];

  for (let i = 0; i < 10; i += 1) {
    const radius = i % 2 === 0 ? outerRadius : innerRadius;
    const angle = -Math.PI / 2 + (i * Math.PI) / 5;
    const x = Number((cx + Math.cos(angle) * radius).toFixed(2));
    const y = Number((cy + Math.sin(angle) * radius).toFixed(2));
    parts.push(`${i === 0 ? 'M' : 'L'}${x},${y}`);
  }

  parts.push('Z');
  return parts.join('');
}

export function significanceStarX(barWidth: number, value: number, gap = GTP_SIGNIFICANCE_STAR_GAP): number {
  return value < 0 ? -gap : barWidth + gap;
}

export function significanceStarXs(
  barWidth: number,
  value: number,
  count: number,
  gap = GTP_SIGNIFICANCE_STAR_GAP,
): number[] {
  if (count <= 0) return [];
  const first = significanceStarX(barWidth, value, gap);
  const step = value < 0 ? -GTP_SIGNIFICANCE_STAR_SPACING : GTP_SIGNIFICANCE_STAR_SPACING;
  return Array.from({ length: count }, (_, index) => first + index * step);
}
